import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';

export const ctbRoutes: Routes = [
  {
    path: 'geracao-sped',
    loadChildren: () =>
      import('../pages/ctb/geracao-sped/geracao-sped.module').then(
        (module) => module.GeracaoSpedModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'plano-contabil',
    loadChildren: () =>
      import('../pages/ctb/plano-contabil/plano-contabil.module').then(
        (module) => module.PlanoContabilModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'configurador-contabil',
    loadChildren: () =>
      import('../pages/ctb/configurador-contabil/configurador-contabil.module').then(
        (module) => module.ConfiguradorContabilModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cadastro-generico",
    loadChildren: () =>
      import("../pages/cad/cadastro-generico/cadastro-generico.module").then(
        (module) => module.CadastroGenericoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
];
